export const CoinShortcuts = Object.freeze({
  bitcoin: "BTC",
  tron: "TRX",
  ethereum: "ETH",
  avalanche: "AVAX",
  optimism: "OP",
  arbitrum: "ARB",
  polygon: "MATIC",
  blast: "BLAST",
  "ethereum-classic": "ETC",
  opbnb: "opBNB",
  "polygon-zkevm": "WETH",
  base: "B3",
  "arbitrum-one": "ARB",
  "zksync-era": "ZK",
  linea: "TBA",
  scroll: "SCR",
  bnb: "BNB",
  botanix: "BTX",
  bob: "BOB",
  "gnosis-chain": "GNO",
  fantom: "FTM",
});
